// extracted by mini-css-extract-plugin
export default {"container":"EnterprisePage_container__UFhQE","form":"EnterprisePage_form__egzij","title":"EnterprisePage_title__48N+D","inputGroup":"EnterprisePage_inputGroup__8W+i6"};